export default __webpack_public_path__ + "static/media/1.4f606eb7.png";